import { useAuthStore } from '@/store/auth-store';

export function usePermission() {
    const user = useAuthStore((state) => state.user);
    const roles = user?.roles ?? [];
    const permissions = user?.permissions ?? [];

    const hasPermission = (permission: string): boolean => {
        if (!user) return false;
        if (roles.includes('SUPER_ADMIN')) return true;
        return permissions.includes(permission);
    };

    const hasAnyPermission = (...perms: string[]): boolean => {
        if (!user) return false;
        if (roles.includes('SUPER_ADMIN')) return true;
        return perms.some((p) => permissions.includes(p));
    };

    const hasRole = (role: string): boolean => {
        if (!user) return false;
        return roles.includes(role);
    };

    const isSuperAdmin = (): boolean => {
        return hasRole('SUPER_ADMIN');
    };

    const isPlatformAdmin = (): boolean => {
        return user?.platformAdmin === true;
    };

    return { hasPermission, hasAnyPermission, hasRole, isSuperAdmin, isPlatformAdmin };
}
